import {createUndirectedEdge} from '@src/scenario-editor/render-utils/edges-factory';
import type { CustomNode } from '@src/components/custom-nodes/types';
import type { ReactFlowInstance } from 'reactflow';
import { recalculateHandlePositions } from '@src/scenario-editor/render-utils/recalculate-handle-positions.ts';

export const removeNodeById = (reactFlowInstance: ReactFlowInstance) => (id: string) => {
  reactFlowInstance.setNodes?.((nodes) => {
    const updatedNodes = nodes.filter(node => node.id !== id) as CustomNode[];
    return updatedNodes;
  });
  reactFlowInstance.setEdges((edges) => {
    const sourceEdge = edges.find(edge => edge.target === id)!;
    const targetEdge = edges.find(edge => edge.source === id)!;
    const newEdge = createUndirectedEdge(sourceEdge.source, targetEdge.target)
    const updatedEdges = edges.filter(edge => edge.id !== sourceEdge.id && edge.id !== targetEdge.id);
    const edgesToSet = updatedEdges.concat(newEdge);

    recalculateHandlePositions(reactFlowInstance.getNodes() as CustomNode[], edgesToSet);

    return edgesToSet;
  })
}
